import Scenario from "./scenarioElements/Scenario";
import Step from "./scenarioElements/Step";
import AnalyticsManager from "./AnalyticsManager";
import UIUtils from "./utilities/UIUtils";
import store, {StoreActions} from "../state/store";
import {CustomEventTypes, SimulationStates} from "../globals";
import {GetTimeline} from "../classes/timeline";

export class AppState
{
	static originalStep: Step;
    
	static startSimulation = function (startFromInitialSequence = false)
	{
		if(UIUtils.isEditingVisageTemplate())
		{
			UIUtils.generateExitVisageTemplateEditorDialog(AppState.startSimulation);
			return false;
		}

		const currentStep = Scenario.currentStep();
		if (!currentStep || (currentStep.isDefault() && !startFromInitialSequence)) return false;
		AnalyticsManager.managedClick('Start Simulation', 'Scene View');

		AppState.originalStep = currentStep;
		const timeline = GetTimeline(AppState.originalStep.id);
		if (timeline)
		{
			timeline.update(0);
		}

		if (startFromInitialSequence && Scenario.initialSequence())
		{
			Scenario.setCurrentStep(Scenario.initialSequence()!.steps[0], true);
		}

		store.dispatch(StoreActions.application.setSimulationState(SimulationStates.Playing));

		document.dispatchEvent(new CustomEvent(CustomEventTypes.simulationStarted));
		return true;
	};

	/**
     * stops the scenario playback simulation
     */
	static stopSimulation = function (stayInTheSameStep = false)
	{
		AnalyticsManager.managedClick('Stop Simulation', 'Scene View');
		if(!store.getState().scenarioModule.permissions.canUpdate) return; // simulation never stops users with no update permissions

		store.dispatch(StoreActions.timeline.setCurrentFrame(0));

		const currentStep = Scenario.currentStep();
		const timeline = currentStep && GetTimeline(currentStep?.id);
		if (currentStep?.id !== AppState.originalStep.id && !stayInTheSameStep)
		{
			timeline?.resetAnimations();
			Scenario.setCurrentStep(AppState.originalStep);
		}
		else
		{
			timeline?.update(0);
		}
		store.dispatch(StoreActions.application.setSimulationState(SimulationStates.Stopped));
		store.dispatch(StoreActions.application.setSimulationAsViewer(false));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.simulationStopped));
	};

	static restartSimulation = function (startFromInitialSequence = false)
	{
		const simulationState: SimulationStates = store.getState().applicationModule.simulationState;
		if (simulationState != SimulationStates.Playing) return;
		store.dispatch(StoreActions.checklist.clearAnswers());
		store.dispatch(StoreActions.application.setSimulationState(SimulationStates.Stopped));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.simulationStopped));

		const currentStep = Scenario.currentStep();
		if(!currentStep) return;

		AppState.originalStep = currentStep;
		const timeline = GetTimeline(AppState.originalStep.id);
		if (timeline)
		{
			timeline.update(0);
		}

		if (startFromInitialSequence && Scenario.initialSequence())
		{
			Scenario.setCurrentStep(Scenario.initialSequence()!.steps[0], true);
		}

		store.dispatch(StoreActions.timeline.setCurrentFrame(0));
		store.dispatch(StoreActions.application.setSimulationState(SimulationStates.Playing));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.simulationStarted));
	}
}